import { setShoppingData, cleanShoppingData, getShoppingData } from 'actions/shoppingData'
import { rest } from 'services'
import { setUpdatingBlock } from 'components/common/UpdatingBlock/actions'
import { ADDING_TO_SHOPPING_QUOTE } from 'components/common/UpdatingBlock/constants'
import { show } from 'redux-modal'
import {
  CODE_ITEM_DISCONTINUED_FOR_STORE,
  CODE_ITEM_EXISTS_IN_CART,
  GENERIC_MESSAGE_MODAL,
  SAVE_FOR_LATER_LIST_SOURCE
} from 'constant'
import { isErrorCode } from 'helpers/utils'
import {
  ALREADY_IN_QUOTE,
  ITEM_DISCONTINUED,
  ITEM_IN_CART_MESSAGE
} from 'components/common/hoc/withAddToQuote/constants'
import AlreadyInQuoteSubComponent from 'components/common/hoc/withAddToQuote/components/AlreadyInQuoteSubComponent'
import { googleAnalyticProductAddToCartWithoutQuoteModal, googleAnalyticProductClicks } from 'actions/googleAnalytic'
import { getGTMSaveForLaterData } from 'helpers/googleAnalytic'
import { updateProductsCount } from 'components/common/hoc/withAddToQuote/actions'

export const removeSaveForLaterItemAction = (skuId) => (dispatch, getState) => {
  const { shoppingData: { _state }} = getState()

  return rest.api.removeSaveForLaterItems({ data: _state ? { skuId, _state } : { skuId }})
    .then(shoppingData => {
      dispatch(shoppingData.quotedItemAndServices ? setShoppingData(shoppingData) : cleanShoppingData())
    })
    .catch(e => console.error(e))
}

export const addSavedItemToCart = (skuId, quantity, handleTAOSDateTimeUpdate, product, favoriteSkus) => dispatch => {
  const productData = { skuId, quantity, isSavedItem: true }

  dispatch(getShoppingData(rest.api.addProductToCart, productData))
    .then(shoppingData => {
      dispatch(shoppingData.quotedItemAndServices ? setShoppingData(shoppingData) : cleanShoppingData())
      shoppingData.quotedItemAndServices
        && shoppingData.quotedItemAndServices.products
        && shoppingData.quotedItemAndServices.products.length
        && dispatch(updateProductsCount(shoppingData.quotedItemAndServices.products.length))

      dispatch(googleAnalyticProductAddToCartWithoutQuoteModal(
        { data: getGTMSaveForLaterData({ product, favoriteSkus }), ...SAVE_FOR_LATER_LIST_SOURCE }
      ))
    })
    .catch((err) => {
      if (isErrorCode({ err, code: CODE_ITEM_EXISTS_IN_CART })) {
        const modalOptions = {
          text: ITEM_IN_CART_MESSAGE,
          title: ALREADY_IN_QUOTE,
          SubComponents: AlreadyInQuoteSubComponent
        }
        dispatch(show(GENERIC_MESSAGE_MODAL, modalOptions))
      } else if (isErrorCode({ err, code: CODE_ITEM_DISCONTINUED_FOR_STORE })) {
        const modalOptions = {
          text: err.status.description,
          title: ITEM_DISCONTINUED
        }
        dispatch(show(GENERIC_MESSAGE_MODAL, modalOptions))
      }

      dispatch(setUpdatingBlock({ name: ADDING_TO_SHOPPING_QUOTE, value: null }))
    })
}

export const handleProductClickAction = (product, favoriteSkus) => (dispatch) => {
  dispatch(googleAnalyticProductClicks(
    { data: getGTMSaveForLaterData(product, favoriteSkus), ...SAVE_FOR_LATER_LIST_SOURCE }
  ))
}

